import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  stationCardBody: {
    cursor: "pointer",
    height: "114px",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingTop: "16px",
    paddingBottom: "16px",
    ...shorthands.gap("16px"),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderTop("1px", "solid", tokens.colorNeutralBackground4),
    "@media (min-width: 500px)": {
      ...shorthands.borderTop("none"),
      ...shorthands.borderBottom("1px", "solid", tokens.colorNeutralBackground4),
    },
  },
  stationImage: {
    height: "90px",
    width: "90px",
  },
  stationText: {
    flexDirection: "column",
    width: "100%",
  },
  stationAcceptsOrders: {
    color: tokens.colorPaletteGreenForeground3,
  },
});
